module.exports = __webpack_public_path__ + "img/goHome.c4cfdcb1.png";